import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import "./axios"
import Fragment from 'vue-fragment'
import VueLazyload from 'vue-lazyload'

Vue.prototype.$store = store;
Vue.prototype.$axios = axios;

//工具js
import tool from './tool';
Vue.prototype.$tool = tool;

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Fragment.Plugin)

const loadimage = require('@/assets/img/common/loading.gif')
const errorimage = require('@/assets/img/common/damage.jpg')

Vue.use(VueLazyload, {
  preLoad: 1.3,
  // 懒加载默认加载图片
  loading: loadimage,
  // 加载失败后加载的图片
  error: errorimage,
  attempt: 1
  // the default is ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend']
  // listenEvents: [ 'scroll' ]
})

new Vue({
  router,
  store,
  render: (h) => h(App),
  beforeCreate(){
    //定义全局事件总线
    Vue.prototype.$bus = this
  },
}).$mount("#app");
